/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInMessageStepOverrideLinkedinMessageDoc } from './linkedInMessageStepOverrideLinkedinMessageDoc';

export interface LinkedInMessageStepOverride {
  type: 'linkedin_message';
  linkedin_message_doc?: LinkedInMessageStepOverrideLinkedinMessageDoc;
}
